import React from 'react';
import PaymentFormClaroSocioContainer from '../containers/PaymentFormClaroSocioContainer'
import { Page } from 'react-onsenui';
import * as sdkclaro from '@claro/sdkclaromicrofront'
import { GenericFormContextProvider } from '../../context/genericFormContext';

const PlansPage = ({ match, location }) => {

    const { 
        state: { 
            sdkVersion, 
            paymentsConfig, 
            isClaroPartner,
            amountPlan,
            productId,
            serviceConfigIndex,
            paramsNewOfferTelcel,
            isContainerTelcel,
            idCategory,
            mb,
            isAdvancementClaroPay
        }
    } = location;
  
    sdkclaro.getInstance().switchGoBackButton(true)
    return (
        <Page id="plans-page">
            <GenericFormContextProvider>
                <PaymentFormClaroSocioContainer 
                    serviceConfigIndex={serviceConfigIndex} 
                    sdkVersion = {sdkVersion}
                    paymentsConfig = {paymentsConfig} 
                    isClaroPartner = {isClaroPartner}
                    amountPlan = {amountPlan}
                    productId ={productId}
                    paramsNewOfferTelcel = {paramsNewOfferTelcel}
                    isContainerTelcel={isContainerTelcel}
                    planCategory={idCategory}
                    planBenefits={mb}
                    isAdvancementClaroPay={isAdvancementClaroPay}
                />
            </GenericFormContextProvider>
        </Page>    
  );
};


export default PlansPage